// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* printCounselCauseList.css */

/* Hide elements when printing */
@media print {
    /* Hide all elements with hide-on-print class */
    .hide-on-print {
        display: none !important;
    }
    
    /* Hide date selection section */
    #hideDate {
        display: none !important;
    }
    
    /* Hide all buttons */
    .hideBtn, .btn, button {
        display: none !important;
    }
    
    /* Hide custom section headers */
    .hideCustomHeader {
        display: none !important;
    }
    
    /* Hide custom button section */
    .hideCustomBtn {
        display: none !important;
    }
    
    /* Hide search and filter sections */
    .input-group, .form-control, select.form-control {
        display: none !important;
    }
    
    /* Hide labels and form elements */
    label {
        display: none !important;
    }
    
    /* Hide checkboxes */
    input[type="checkbox"] {
        display: none !important;
    }
    
    /* Hide the date search section */
    .row .col .input-group {
        display: none !important;
    }
    
    /* Hide the location filter row */
    .row.mt-3:has(.hide-on-print) {
        display: none !important;
    }
    
    /* Hide custom header input rows */
    .row.mb-3:has(.hide-on-print) {
        display: none !important;
    }
    
    /* Hide the print instruction paragraph */
    p.hideBtn {
        display: none !important;
    }
    
    /* Hide button groups */
    .button-group {
        display: none !important;
    }
    
    /* Ensure tables print properly */
    .table {
        border-collapse: collapse !important;
        width: 100% !important;
        font-size: 12px !important;
    }
    
    .table th, .table td {
        border: 1px solid black !important;
        page-break-inside: avoid !important;
    }
    
    /* Ensure proper page breaks for sections */
    .counselListHeading {
        page-break-inside: avoid !important;
        page-break-after: auto !important;
    }
    
    /* Hide empty row that might contain filters */
    .row:has(> .col-md-6 > label) {
        display: none !important;
    }
    
    /* Specific selector for location filter */
    .row:has(> .col-md-6 > select) {
        display: none !important;
    }
}

/* Non-print styles */
.hide-on-print {
    /* These elements will be visible on screen but hidden when printing */
}

/* Ensure proper table layout */
.table th[style*="width: 80px"] {
    min-width: 80px !important;
    max-width: 80px !important;
}

/* Custom header text styling */
.custom-header-text {
    font-weight: bold;
    font-size: 18px;
    text-align: center;
    margin-bottom: 20px;
}

/* Main list styling */
#divToPrintCounselCauseList {
    margin-bottom: 30px;
}

/* Custom list styling */
#customCauseListPrint {
    margin-top: 30px;
}`, "",{"version":3,"sources":["webpack://./src/app/dashboard/causeList/CounselCauseListCustomPrint.css"],"names":[],"mappings":"AAAA,8BAA8B;;AAE9B,gCAAgC;AAChC;IACI,+CAA+C;IAC/C;QACI,wBAAwB;IAC5B;;IAEA,gCAAgC;IAChC;QACI,wBAAwB;IAC5B;;IAEA,qBAAqB;IACrB;QACI,wBAAwB;IAC5B;;IAEA,gCAAgC;IAChC;QACI,wBAAwB;IAC5B;;IAEA,+BAA+B;IAC/B;QACI,wBAAwB;IAC5B;;IAEA,oCAAoC;IACpC;QACI,wBAAwB;IAC5B;;IAEA,kCAAkC;IAClC;QACI,wBAAwB;IAC5B;;IAEA,oBAAoB;IACpB;QACI,wBAAwB;IAC5B;;IAEA,iCAAiC;IACjC;QACI,wBAAwB;IAC5B;;IAEA,iCAAiC;IACjC;QACI,wBAAwB;IAC5B;;IAEA,kCAAkC;IAClC;QACI,wBAAwB;IAC5B;;IAEA,yCAAyC;IACzC;QACI,wBAAwB;IAC5B;;IAEA,uBAAuB;IACvB;QACI,wBAAwB;IAC5B;;IAEA,iCAAiC;IACjC;QACI,oCAAoC;QACpC,sBAAsB;QACtB,0BAA0B;IAC9B;;IAEA;QACI,kCAAkC;QAClC,mCAAmC;IACvC;;IAEA,2CAA2C;IAC3C;QACI,mCAAmC;QACnC,iCAAiC;IACrC;;IAEA,8CAA8C;IAC9C;QACI,wBAAwB;IAC5B;;IAEA,0CAA0C;IAC1C;QACI,wBAAwB;IAC5B;AACJ;;AAEA,qBAAqB;AACrB;IACI,sEAAsE;AAC1E;;AAEA,+BAA+B;AAC/B;IACI,0BAA0B;IAC1B,0BAA0B;AAC9B;;AAEA,+BAA+B;AAC/B;IACI,iBAAiB;IACjB,eAAe;IACf,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA,sBAAsB;AACtB;IACI,mBAAmB;AACvB;;AAEA,wBAAwB;AACxB;IACI,gBAAgB;AACpB","sourcesContent":["/* printCounselCauseList.css */\n\n/* Hide elements when printing */\n@media print {\n    /* Hide all elements with hide-on-print class */\n    .hide-on-print {\n        display: none !important;\n    }\n    \n    /* Hide date selection section */\n    #hideDate {\n        display: none !important;\n    }\n    \n    /* Hide all buttons */\n    .hideBtn, .btn, button {\n        display: none !important;\n    }\n    \n    /* Hide custom section headers */\n    .hideCustomHeader {\n        display: none !important;\n    }\n    \n    /* Hide custom button section */\n    .hideCustomBtn {\n        display: none !important;\n    }\n    \n    /* Hide search and filter sections */\n    .input-group, .form-control, select.form-control {\n        display: none !important;\n    }\n    \n    /* Hide labels and form elements */\n    label {\n        display: none !important;\n    }\n    \n    /* Hide checkboxes */\n    input[type=\"checkbox\"] {\n        display: none !important;\n    }\n    \n    /* Hide the date search section */\n    .row .col .input-group {\n        display: none !important;\n    }\n    \n    /* Hide the location filter row */\n    .row.mt-3:has(.hide-on-print) {\n        display: none !important;\n    }\n    \n    /* Hide custom header input rows */\n    .row.mb-3:has(.hide-on-print) {\n        display: none !important;\n    }\n    \n    /* Hide the print instruction paragraph */\n    p.hideBtn {\n        display: none !important;\n    }\n    \n    /* Hide button groups */\n    .button-group {\n        display: none !important;\n    }\n    \n    /* Ensure tables print properly */\n    .table {\n        border-collapse: collapse !important;\n        width: 100% !important;\n        font-size: 12px !important;\n    }\n    \n    .table th, .table td {\n        border: 1px solid black !important;\n        page-break-inside: avoid !important;\n    }\n    \n    /* Ensure proper page breaks for sections */\n    .counselListHeading {\n        page-break-inside: avoid !important;\n        page-break-after: auto !important;\n    }\n    \n    /* Hide empty row that might contain filters */\n    .row:has(> .col-md-6 > label) {\n        display: none !important;\n    }\n    \n    /* Specific selector for location filter */\n    .row:has(> .col-md-6 > select) {\n        display: none !important;\n    }\n}\n\n/* Non-print styles */\n.hide-on-print {\n    /* These elements will be visible on screen but hidden when printing */\n}\n\n/* Ensure proper table layout */\n.table th[style*=\"width: 80px\"] {\n    min-width: 80px !important;\n    max-width: 80px !important;\n}\n\n/* Custom header text styling */\n.custom-header-text {\n    font-weight: bold;\n    font-size: 18px;\n    text-align: center;\n    margin-bottom: 20px;\n}\n\n/* Main list styling */\n#divToPrintCounselCauseList {\n    margin-bottom: 30px;\n}\n\n/* Custom list styling */\n#customCauseListPrint {\n    margin-top: 30px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
